import { Link } from 'react-router-dom';
import { breakingFeed } from '@/mocks/ranking';

export default function BreakingTicker() {
  const items = [...breakingFeed, ...breakingFeed];

  return (
    <section aria-label="突发新闻滚动播报" className="w-full border-b border-primary-700 bg-primary-500">
      <div className="flex w-full items-stretch">
        <div className="flex shrink-0 items-center gap-1.5 bg-primary-700 px-3 py-2 text-xs font-medium text-background-50 md:px-4 md:text-sm">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-flashlight-fill text-base" />
          </span>
          <span className="whitespace-nowrap">突发速递</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max animate-marquee items-center py-2">
            {items.map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/topic/${item.slug}`}
                className="flex shrink-0 cursor-pointer items-center gap-2 px-5 text-xs text-background-50 transition-opacity hover:opacity-80 md:text-sm"
              >
                <span className="whitespace-nowrap text-background-50/70">{item.time}</span>
                <span className="whitespace-nowrap">{item.title}</span>
                <span className="flex h-3 w-3 items-center justify-center text-background-50/60">
                  <i className="ri-arrow-right-s-line text-base" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}